import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import {
  getCouponList,
  setData,
  stepAddMessage,
  stepDeleteMessage,
  stepDownMessage,
  stepUpMessage,
} from '../../../features/ecBindingSlice';
import Button from '../../shared/Button';
import Messages from '../../shared/Messages';
import Preview from '../../shared/MessagesPreview';
import Header from './Header';
import NotifyRecipient from './NotifyRecipient';
import SuccessTag from './SuccessTag';
import SuccessTriggerAction from './SuccessTriggerAction';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      position: 'relative',
    },
    setting: {
      width: 'calc(100% - 360px + 44px)',
    },
  },
  {
    name: 'Step4Container',
  },
);

const Step4Container = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const { data, couponList, isSaved } = useSelector(store => store.ecBinding);
  const { bindResult } = data || {};
  const { success } = bindResult || {};
  const {
    tag: successTag,
    messages: successMessages,
    triggerCoupon,
    notifyRecipient,
  } = success || {};

  const handleSuccessTagChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          success: {
            ...success,
            tag: value,
          },
        },
      }),
    );
  };

  const handleSuccessTriggerActionChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          success: {
            ...success,
            triggerCoupon: {
              ...triggerCoupon,
              ...value,
            },
          },
        },
      }),
    );
  };

  const handleMessagesChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          success: {
            ...success,
            ...value,
          },
        },
      }),
    );
  };

  const handleNotifyRecipientChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          success: {
            ...success,
            notifyRecipient: value,
          },
        },
      }),
    );
  };

  const handleNext = () => {
    history.push(`/${provider}/${orgId}/step5`);
  };

  useEffect(() => {
    if (!couponList?.length) dispatch(getCouponList(orgId));
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <NotifyRecipient
          notifyRecipient={notifyRecipient}
          onChange={handleNotifyRecipientChange}
        />
        <Messages
          addMessage={stepAddMessage}
          deleteMessage={stepDeleteMessage}
          upMessage={stepUpMessage}
          downMessage={stepDownMessage}
          isSaved={isSaved}
          messages={successMessages}
          onChange={handleMessagesChange}
          platform="ig"
        />
        <SuccessTag
          successTag={successTag}
          onSuccessTagChange={handleSuccessTagChange}
        />
        <SuccessTriggerAction
          selectCouponList={couponList}
          data={triggerCoupon}
          onChange={handleSuccessTriggerActionChange}
        />
        <div>
          <Button topic="primaryGreen" onClick={handleNext}>
            {t('next')}
          </Button>
        </div>
      </div>
      <Preview messages={successMessages} />
    </div>
  );
};

export default Step4Container;
